import ToTopIcon from '~/icons/iconography/arrow/up.svg';
import { useTranslations } from '~/services/umbraco/hooks';
import { StyledLinkAnimationText } from '~/shared/styles/Link';
import {
    RemoveAddedPageHeight,
    ScrollLink,
    ScrollToTopContainer,
    ScrollToTopText,
    Wrapper,
} from './styled';

export default function ScrollToTop() {
    const { translate } = useTranslations();

    return (
        <>
            <RemoveAddedPageHeight />
            <Wrapper>
                <ScrollToTopContainer>
                    <ScrollLink
                        animation="reverse"
                        multipleElements
                        title={translate('generic.toTheTop')}
                        onClick={() => {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                        as="button"
                    >
                        <ScrollToTopText>
                            <StyledLinkAnimationText>
                                {translate('generic.toTheTop')}
                            </StyledLinkAnimationText>
                            <ToTopIcon />
                        </ScrollToTopText>
                    </ScrollLink>
                </ScrollToTopContainer>
            </Wrapper>
        </>
    );
}
